/**
 * HauNow theme — main JS entry.
 */

import { initMobileNav, initDesktopMenu } from './modules/nav.js';
import { initHeroSlider } from './modules/hero-slider.js';
import { initShopFilters } from './modules/shop-filters.js';
import { initAccordions } from './modules/accordion.js';
import { initFkcartRefresh } from './modules/fkcart-refresh.js';
import { initSingleProduct } from './modules/single-product.js';
import { initTrustmateCards } from './modules/trustmate-cards.js';
import { initSideCart } from './modules/side-cart.js';
import { initShopList } from './modules/shop-list.js';
import { initCardVariants } from './modules/card-variants.js';
import { initCardVariantSelector } from './modules/card-variant-selector.js';
import { initCheckoutCoupon } from './modules/checkout-coupon.js';
import { initCheckoutShippingRefresh } from './modules/checkout-shipping-refresh.js';
import { initCheckoutPostcodeLookup } from './modules/checkout-postcode-lookup.js';
import { initCheckoutAutoCapitalize } from './modules/checkout-auto-capitalize.js';
import { initCheckoutEmailTypoCheck } from './modules/checkout-email-typo-check.js';
import { initCheckoutInlineToggles } from './modules/checkout-inline-toggles.js';
import { initCheckoutInvoice } from './modules/checkout-invoice.js';
import { initCheckoutCartQty } from './modules/checkout-cart-qty.js';
import { initCheckoutPayment } from './modules/checkout-payment.js';
import { initCheckoutLayout } from './modules/checkout-layout.js';
import { initCheckoutTermsValidate } from './modules/checkout-terms-validate.js';
import { initCheckoutPaczkomatValidate } from './modules/checkout-paczkomat-validate.js';
import { initCheckoutFieldValidate } from './modules/checkout-field-validate.js';
import { initCheckoutSubmitLock } from './modules/checkout-submit-lock.js';
import { initCheckoutProgressScroll } from './modules/checkout-progress-scroll.js';
import { initCheckoutToast } from './modules/checkout-toast.js';
import { initCheckoutMobileSummary } from './modules/checkout-mobile-summary.js';
import { initCartQtyLive } from './modules/cart-qty-live.js';
import { initPaynowDisclaimer } from './modules/paynow-disclaimer.js';
import { initBlogLeadMagnet } from './modules/blog-lead-magnet.js';
import { initSearchToggle } from './modules/search-toggle.js';
import { initHeaderSticky } from './modules/header-sticky.js';
import { initQuiz } from './modules/quiz.js';
import { initBreedQuiz } from './modules/breed-quiz.js';
import { initSubscription } from './modules/subscription.js';
import { initKcal } from './modules/kcal.js';
import { initBcs } from './modules/bcs.js';
import { initAnalyzer } from './modules/analyzer.js';
import { initDryMatter } from './modules/dry-matter.js';
import { initMultiselect } from './modules/multiselect.js';
import { initBackInStock } from './modules/back-in-stock.js';
import { initSingleProductATC } from './modules/single-product-atc.js';
import { initPetOnboarding } from './modules/pet-onboarding.js';
import { initPetProfiles } from './modules/pet-profiles.js';
import { initThankyouAccountCreate } from './modules/thankyou-account-create.js';
import { initMyAccountAddresses } from './modules/myaccount-addresses.js';
import { initCheckoutAddressPicker } from './modules/checkout-address-picker.js';
import { initUgcCarousel } from './modules/ugc-carousel.js';
import { initPdpLazy } from './modules/pdp-lazy.js';
import { initNewTabLinks } from './modules/new-tab-links.js';

document.addEventListener('DOMContentLoaded', () => {
    document.body.classList.add('hn-loaded');

    initMobileNav();
    initDesktopMenu();
    initNewTabLinks();
    initHeroSlider();
    initShopFilters();
    initAccordions();
    initFkcartRefresh();
    initSingleProduct();
    initTrustmateCards();
    initSideCart();
    initShopList();
    initCardVariants();
    initCardVariantSelector();
    initCheckoutCoupon();
    initCheckoutShippingRefresh();
    initCheckoutPostcodeLookup();
    initCheckoutAutoCapitalize();
    initCheckoutEmailTypoCheck();
    initCheckoutInlineToggles();
    initCheckoutInvoice();
    initCheckoutCartQty();
    initCheckoutPayment();
    initCheckoutLayout();
    initCheckoutTermsValidate();
    initCheckoutPaczkomatValidate();
    initCheckoutFieldValidate();
    initCheckoutSubmitLock();
    initCheckoutProgressScroll();
    initCheckoutToast();
    initCheckoutMobileSummary();
    initCartQtyLive();
    initPaynowDisclaimer();
    initBlogLeadMagnet();
    initSearchToggle();
    initHeaderSticky();
    initQuiz();
    initBreedQuiz();
    initSubscription();
    initKcal();
    initBcs();
    initAnalyzer();
    initDryMatter();
    initMultiselect();
    initBackInStock();
    initSingleProductATC();
    initPetOnboarding();
    initPetProfiles();
    initThankyouAccountCreate();
    initMyAccountAddresses();
    initCheckoutAddressPicker();
    initUgcCarousel();
    initPdpLazy();

    if (window.location.hostname === 'haunow.local' || window.location.hostname === 'b2b.haunow.local') {
        // eslint-disable-next-line no-console
        console.log('🐾 HauNow theme — sesja 4 (footer + WC + homepage) loaded.');
    }
});
